











































































import { changeAbtestScene } from "@/services/api";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ABTestCustomDialog from "./customDialog.vue";

@Component({
  components: { ABTestCustomDialog },
})
export default class ABTestEditTable extends Vue {
  @Prop()
  tableDetail?: any;

  @Prop({ type: Boolean, default: false })
  smartMode!: boolean;

  @Prop({ type: String, default: "" })
  baselineFormId!: string;

  @Prop({ type: Boolean, default: false })
  compactLastRow!: boolean;

  tableData: any[] = [];

  type = 0;
  baselineEditDialogShow = false;
  pendingEditScope: { row?: { type?: number; formId?: string }; $index?: number } | null = null;
  baselineEditDialogConfig = {
    title: "",
    desc: "",
    type: "smartEditBaseline",
    okText: "",
    cancelText: "",
  };

  isBaselineRow(scope: { row?: { formId?: string }; $index?: number }) {
    if (!this.smartMode) return false;
    const id = this.baselineFormId;
    if (id) return scope?.row?.formId === id;
    return scope?.$index === 0;
  }

  mounted() {
    this.syncFromDetail();
  }

  @Watch('tableDetail', { deep: true })
  onTableDetailChange() {
    this.syncFromDetail();
  }

  syncFromDetail() {
    this.tableData = this.tableDetail?.abFormList || [];
    this.type = this.tableDetail?.sceneType || 0;
    // Smart 默认 50/50：仅补空值，不覆盖用户已改流量
    if (this.smartMode && this.tableData.length) {
      this.tableData.forEach((row: any) => {
        if (row.flowRate == null || row.flowRate === "") {
          row.flowRate = 50;
        }
      });
    }
  }

  changeType(scene: number) {
    if (this.smartMode) {
      return;
    }
    this.type = scene;
    if (scene != this.tableDetail.sceneType) {
      changeAbtestScene({
        id: this.tableDetail.id,
        sceneType: scene,
      }).then(() => {
        this.$emit('changeDetail');
      }).catch(() => {});
    }
    if (scene === 0) {
      window?.gtagClick('form_abTest_versionBased','弹窗_编辑ab测试_使用版本差异的ab测试')
    } else if (scene === 1) {
      window?.gtagClick('form_abTest_enableBased','弹窗_编辑ab测试_使用是否开启的ab测试')
    }
  }

  /** 与线上普通 AB 创建一致：改一侧，另一侧自动补到 100% */
  changeEditLiuliang(scope: any, index: number) {
    if (scope.row.flowRate >= 100) {
      scope.row.flowRate = 99;
    } else if (scope.row.flowRate <= 0) {
      scope.row.flowRate = 1;
    } else {
      scope.row.flowRate = parseInt(scope.row.flowRate);
    }
    this.tableData[index].flowRate = scope.row.flowRate;
    if (this.tableData.length > 1) {
      this.tableData[this.tableData.length - 1 - index].flowRate = 100 - scope.row.flowRate;
    }
    setTimeout(() => {
      this.$emit('saveDraftNoTip');
    }, 100);
  }

  editItem(scope: { row?: { type?: number; formId?: string }; $index?: number }) {
    if (this.isBaselineRow(scope)) {
      this.pendingEditScope = scope;
      this.baselineEditDialogConfig = {
        title: this.$tx("form.smartAb.editBaselineTitle", "基线组不建议修改"),
        desc: this.$tx(
          "form.smartAb.editBaselineDesc",
          "基线组用于提供对照基准，一旦改动，实验会混入额外变量，数据可信度随之降低。如确需调整，建议新建实验组。",
        ),
        type: "smartEditBaseline",
        okText: this.$tx("form.smartAb.editBaselineOk", "仍要修改"),
        cancelText: this.$tx("common.cancel", "取消"),
      };
      this.baselineEditDialogShow = true;
      return;
    }
    this.goEdit(scope);
  }

  confirmBaselineEdit(callback?: (success: boolean) => void) {
    const scope = this.pendingEditScope;
    this.pendingEditScope = null;
    if (callback) {
      callback(true);
    }
    this.goEdit(scope);
  }

  goEdit(scope: { row?: { type?: number; formId?: string }; $index?: number } | null) {
    if (!scope || !scope.row) {
      return;
    }
    if (scope.row.type == 1) {
      this.$router.push(`/wheel_of_fortune/setting/${scope.row.formId}?abtest=true&edit=true&idx=${scope.$index}&abtestid=${this.tableDetail.id}`)
    } else if (scope.row.type == 2) {
      this.$router.push(`/wheel_of_fortune/pop/${scope.row.formId}?abtest=true&edit=true&idx=${scope.$index}&abtestid=${this.tableDetail.id}`)
    }
  }

  delItem(index: number) {
    // Smart：基线不可删除
    if (this.smartMode) {
      const row = this.tableData[index];
      if (this.isBaselineRow({ row, $index: index })) {
        return;
      }
    }
    this.$emit('deleteItem', index);
  }
}
